export const DEFAULT_CATEGORY = "fruits";
